import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Layout from "../../../common/Layout";
import Breadcrumb from "../../../common/breadcrumb/Breadcrumb";
// import ServicesTypeOne from "../../../components/services/services-one/ServicesTypeOne";
// import SectionTitle from "../../../components/section-title/SectionTitle";
import ClientLogo from "../../../components/client-logo/ClientLogo";
import { Helmet } from "react-helmet";

const ServiceDetailsOne = () => {
  const [services, setServices] = useState(null);

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await fetch(
          "https://rss.fastwebforge.com/api/list/services"
        );
        const data = await response.json();
        setServices(data);
      } catch (error) {
        console.error("Error fetching site settings:", error);
      }
    };

    fetchSiteSettings();
  }, []);

//   console.log("services", services);

  const { id } = useParams();
  // const serviceData = getServiceData.filter( service => service.id === parseInt(id) )[0];
  let heroSection = null;
  if (services && services.data) {
    heroSection = services.data.filter(
      (service) => service.id === parseInt(id)
    )[0];
  }

//   console.log("dd", heroSection);

  return (
    <>
      <Helmet>
        <title>
         RSS Security and Investigations Pty Ltde
        </title>
        <meta
          name="description"
          content="Securepress - Security Company React  Template"
        />
        <meta
          name="keywords"
          content="safety, bodyguard, cctv, emergency, Event Security, fire, investigation, investigator, officer, protection, security, Security Camera, Care, Parking  Security"
        />
      </Helmet>
      <Layout>
        <Breadcrumb
          pageTitle={heroSection && heroSection.title ? heroSection.title : null}
          rootPath="/"
          parentPath="Home"
          currentPath={heroSection && heroSection.title ? heroSection.title : null}
        />
        <div className="about-us-sec pt-100 pb-100">
          <div className="container">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div className="abt-img">

                  <img src={heroSection && heroSection.thumbnail ? heroSection.thumbnail : "/images/no-image.png"} alt="backgroundimage" />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                <div className="abt-lft">
                  <h2>
                    {heroSection && heroSection.title
                      ? heroSection.title
                      : null}
                  </h2>

                  
                  {/* <p>very property, business, and event is different — your security should be too. We don’t believe in one-size-fits-all protection. Our customized security solutions are designed specifically for your risks, environment, and objectives. From staffing to technology, we build security that works for you.</p>
                  <p className="font-bold">We Customize:</p>
                  <ul>
                    <li>Static guarding & mobile patrol combinations</li>
                    <li>Alarm response protocols & keyholding</li>
                    <li>Access control systems & visitor management</li>
                    <li>Event security & crowd management strategies</li>
                    <li>K9 units for high-risk or large-area coverage</li>
                    <li>CCTV installation and remote monitoring integration</li>

                  </ul> */}
                  {/* <p className="mt-3">Act as a fire warden when trained and appointed for the particular facility. Currently our static guards are working in following industries</p> */}

                  {/* <ul>
                    <li>Office buildings & commercial properties</li>
                    <li>Construction sites</li>
                    <li>Government facilities </li>
                    <li>Hospitals & educational campuses</li>
                    <li>Retail stores & shopping centres</li>
                    <li>Industrial and warehouse sites</li>

                  </ul> */}

                  <div
                    dangerouslySetInnerHTML={{ __html: heroSection && heroSection.description ? heroSection.description : null }}
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <ClientLogo /> */}
      </Layout>
    </>
  );
};

export default ServiceDetailsOne;
